<template>
    <section>
        <div class="page">
            <div>
                <h2>Managing your profile</h2>
                <h3>Profile photo</h3>
                <ol>
                    <li>Go to ToTok > tap <strong>Me</strong> > tap your nickname.</li>
                    <li>Tap <strong>Profile Avatar</strong>.
                    </li>
                    <li>You can choose a photo from your gallery, or take a new photo with your camera.
                    </li>
                </ol>
                <h3>Name</h3>
                <ol>
                    <li>Go to ToTok > tap <strong>Me</strong> > tap your nickname.</li>
                    <li>Tap Nickname.
                    </li>
                    <li>Set your new nickname.</li>
                </ol>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
